/* eslint-disable import/prefer-default-export */

/**
 * pipe
 * @example
 * const a = pipe(
  *   v => v + 1,
  *   v => v * 5,
  * )(1) // a --> 10
  *
  * pipe(
  *   v => {
  *     console.log(v);
  *     return v + 1;
  *   },
  *   v => {
  *     console.log(v);
  *     return v * 5
  *   },
  *   v => console.log(v)
  * )(1) // log 1 then log 2 and then log 10
  */
function pipe(...func) {
  return func.reduce((acc, cur) => arg => cur(acc(arg)), arg => arg);
}

module.exports = { pipe };
